import React, { Component } from 'react';

import { oneOfType, object, array } from 'prop-types';

import { notify } from 'Utils';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // error: '',
      errorInfo: '',
      hasError: false
    };
  }

  // receives the erro
  static getDerivedStateFromError(error) {
    console.log('getDerivedStateFromError', { error });
    return {
      hasError: true,
      error
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.log('error, errorInfo', { error, errorInfo });
    notify({ message: 'Something went wrong', type: 'error' });
  }

  render() {
    const { hasError, errorInfo } = this.state;
    const { children } = this.props;

    return hasError ? (
      <div className="card my-5" data-testid="errorBoundary-component">
        <div className="card-header">
          <p>
            An error has occurred in this component.{' '}
            <span
              role="button"
              tabIndex={0}
              style={{ cursor: 'pointer', color: '#0077FF' }}
              onKeyPress={() => {
                window.location.reload();
              }}
              onClick={() => {
                window.location.reload();
              }}
            >
              Reload this page
            </span>{' '}
          </p>
        </div>
        <div className="card-body">
          <details className="error-details">
            <summary>Click for error details</summary>
            {errorInfo && errorInfo.componentStack.toString()}
          </details>
        </div>
      </div>
    ) : (
      children
    );
  }
}

ErrorBoundary.propTypes = {
  children: oneOfType([object, array]).isRequired
};
